<template>
  <div
    class="ce-formulationIngredients"
    v-if="formulation.ingredients">
    <h2>
      {{ $t('formulationRepository.detailPage.ingredients.headline') }}
    </h2>

    <table class="ce-dataTable">
      <tr>
        <th>
          {{ $t('formulationRepository.detailPage.ingredients.product') }}
        </th>
        <th>
          {{ $t('formulationRepository.detailPage.ingredients.percentage') }}
        </th>
      </tr>
      <FormulationIngredient
        v-for="(ingredient, index) in formulation.ingredients"
        :key="`ingredient-${ingredient.id}`"
        :style="(index + 1) % 2 ? 'background: ' + fadedBgColor : ''"
        :ingredient="ingredient" />
    </table>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import FormulationIngredient from './FormulationIngredient.vue';

export default {
  components: {
    FormulationIngredient,
  },
  computed: {
    ...mapState(['formulation']),
    ...mapState('generic', ['links']),
    ...mapGetters(['fadedBgColor']),
    ...mapGetters('user', ['isInternal']),
  },
};
</script>
